import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import storage from "./utils/storage";
import { getParams } from "./utils/authUtils";
import PPIService from "./services/PPIService";
import Swal from "sweetalert2";

import Loader from "./components/Loader";
import CardIntro from "./pages/CardIntro";
import Dashboard from "./pages/CardHome/Dashboard";
import Unauthorized from "./pages/Unauthorized";
import MinKyc from "./pages/MinKYC/MinKYC";
import MinKycOtpVerify from "./pages/MinKYC/OtpVerify";
import MinKycVerifyDocument from "./pages/MinKYC/VerifyDocument";
import IssueDigitalCard from "./pages/CardHome/IssueDigitalCard";

function App() {
  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(null);
  const [isUser, setIsUser] = useState(null);

  // First effect: check and set token + source
  useEffect(() => {
    const initAuth = () => {
      const { token, logo_url, brand_name, source } = getParams();

      if (token && source) {
        storage.setItem("access_token", token);
        storage.setItem("logo_url", logo_url || "");
        storage.setItem("brand_name", brand_name || "");
        storage.setItem("source", source);
        setAuthorized(true);
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname
        );
      } else {
        const storedToken = storage.getItem("access_token");
        const storedSource = storage.getItem("source");
        setAuthorized(!!(storedToken && storedSource));
      }
    };

    initAuth();
  }, []);

  // Second effect: fetch user status only after auth is confirmed
  useEffect(() => {
    const fetchUserStatus = async () => {
      try {
        const result = await PPIService.getPPIUserStatus();

        if (!result.success) {
          Swal.fire(
            "Oops!",
            result.message || "Failed to fetch user status",
            "error"
          );
          setIsUser(false);
        } else {
          const responseData = result.data;
          if (responseData?.data?.min_kyc_status === "true") {
            setIsUser(true);
          } else {
            setIsUser(false);
          }
        }
      } catch (error) {
        Swal.fire(
          "Oops!",
          error?.response?.data?.message || error.message || "Request Failed",
          "error"
        );
        setIsUser(false);
      } finally {
        setLoading(false);
      }
    };

    if (authorized === true) {
      fetchUserStatus();
    } else if (authorized === false) {
      setLoading(false);
    }
  }, [authorized]);

  if (loading || authorized === null) return <Loader />;

  return (
    <Router>
      <Routes>
        {!authorized && <Route path="*" element={<Unauthorized />} />}

        {authorized && isUser === false && (
          <Route path="*" element={<CardIntro />} />
        )}

        {authorized && isUser === true && (
          <Route path="/" element={<Dashboard />} />
        )}

        {/* Public or Auth routes */}
        <Route path="/min-kyc" element={<MinKyc />} />
        <Route path="/min-kyc/verify-otp" element={<MinKycOtpVerify />} />
        <Route
          path="/min-kyc/verify-document"
          element={<MinKycVerifyDocument />}
        />
        <Route path="/issue-digital-card" element={<IssueDigitalCard />} />
        <Route path="/dashboard" element={<Dashboard />} />
      </Routes>
    </Router>
  );
}

export default App;
